module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('breadcrumbs-layout', {
    attrs: {
      "bg": "grey",
      "breadcrumbs": _vm.breadcrumbs
    }
  }, [(_vm.isContainData) ? _c('catalog-list', {
    attrs: {
      "items": _vm.eventsList,
      "doubler": false
    }
  }, [_c('filter-yellow', _vm._b({
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  }, 'filter-yellow', _vm.filterProps, false)), _c('catalog-sort', {
    key: _vm.sort,
    attrs: {
      "slot": "before",
      "items": _vm.sortList
    },
    slot: "before"
  }), (_vm.pagesCount > 1) ? _c('PaginatorDefault', {
    attrs: {
      "slot": "after",
      "count": _vm.pagesCount,
      "current": parseInt(_vm.page),
      "max": 6
    },
    slot: "after"
  }) : _vm._e(), _c('SelectCount', {
    attrs: {
      "slot": "right",
      "options": _vm.pageLimits,
      "value": _vm.limit,
      "text": "Программ на странице"
    },
    on: {
      "change": _vm.pageLimitChange
    },
    slot: "right"
  })], 1) : _c('SiteMap', {
    attrs: {
      "title": "К сожалению, нам не удалось найти ничего идеально подходящего.",
      "map": _vm.mainNav
    }
  }, [_c('filter-yellow', _vm._b({
    attrs: {
      "slot": "sidebar"
    },
    slot: "sidebar"
  }, 'filter-yellow', _vm.filterProps, false)), _vm._v("Попробуйте воспользовать формой слева используя менее узкие критерии подбора\nили воспользуйтесь списком категорий для поиска программы.")], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0ca9fd0","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/event/list/List.vue
// module id = 7111ce2e85e1fd4b0ace
// module chunks = 38